class FiskalyItController extends FiskalyController
	@register()

	integrationId: 'fiskaly_it'

	reset: (newConfiguration = {}) ->
		super(newConfiguration)

		@hasCredentialsPassword = @configuration.taxpayer?.fiscalization?.credentials?.password?
